import {
  FALLBACK_ERROR_MESSAGE,
  INVALID_INPUT_MESSAGE,
  INVALID_RECAPTCHA_MESSAGE,
  SUPPORT_EMAIL_MAIL_TO,
} from "@/constants"

export const errors = {
  INVALID_INPUT: INVALID_INPUT_MESSAGE,
  CAPTCHA_FAILED: {
    title: `reCAPTCHA failed`,
    message: `We were unable to validate your request. Please refresh your browser and try again`,
    links: [{ label: `Contact us`, href: SUPPORT_EMAIL_MAIL_TO }],
  },
  INVALID_RECAPTCHA: INVALID_RECAPTCHA_MESSAGE,
  FALLBACK_ERROR: FALLBACK_ERROR_MESSAGE,
}
